import React, { useEffect, useState } from "react";
import VerifyNumberAbha from "../abhanumber-details/verify-number-abha";
import { AlreadyAbhaVerifyAddress, EncryptDataABDM } from "../../services";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setResentCount } from "../../redux/slices/abhaSlice";

import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";

const VerifyAbhaAddress = ({
  inputValue,
  setResMessage,
  resMessage,
  handleBack,
}) => {
  const [verifyNumberAbha, setVerifyNumberAbha] = useState(false);
  const [consent, setConsent] = useState(false);
  const [authMethod, setAuthMethod] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [abhaDetails, setAbhaDetails] = useState(null);
  const [selectedAbha, setSelectedAbha] = useState(null);

  const resendCount = useSelector((state) => state.user.resentCount);
  const dispatch = useDispatch();

  useEffect(() => {
    const storedAbhaDetails = localStorage.getItem("abhaDetails");
    if (storedAbhaDetails) {
      try {
        const parsed = JSON.parse(storedAbhaDetails);

        if (parsed.data || parsed.abha) {
          const source = parsed.data || parsed.abha;

          setAbhaDetails({
            abha: {
              name: source.fullName || source.name,
              ABHANumber: source.healthIdNumber || source.ABHANumber,
              abhaAddress: source.abhaAddress,
              gender: source.gender || "N/A",
              kycVerified: source.kycVerified || false,
            },
            inputValue: source.mobile || parsed.inputValue,
          });
        } else {
          setAbhaDetails(parsed);
        }
      } catch (err) {
        console.error("Invalid ABHA details in localStorage", err);
      }
    }
  }, []);

  const getAbhaList = () => {
    if (!abhaDetails) return [];
    if (Array.isArray(abhaDetails.abha)) return abhaDetails.abha;
    if (typeof abhaDetails.abha === "object") return [abhaDetails.abha];
    return [];
  };

  const handleCardSelect = (item) => {
    setSelectedAbha(item);
  };

  const handleVerifyNumberAbha = async (e) => {
    e.preventDefault();

    if (!consent) {
      toast.error("Please accept the consent checkbox.");
      return;
    }

    if (!authMethod) {
      toast.error("Please select an authentication method (Mobile / Aadhaar).");
      return;
    }

    if (!abhaDetails) {
      toast.error("No ABHA details found.");
      return;
    }

    if (!selectedAbha) {
      toast.error("Please select an ABHA card.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const encryptedInput = await EncryptDataABDM({ body: inputValue });

      let requestData = {};
      if (authMethod === "mobile") {
        requestData = {
          scope: ["abha-address-login", "mobile-verify"],
          loginHint: "abha-address",
          loginId: encryptedInput.data,
          otpSystem: "abdm",
          resent_count: resendCount,
        };
      } else if (authMethod === "aadhaar") {
        requestData = {
          scope: ["abha-address-login", "aadhaar-verify"],
          loginHint: "abha-address",
          loginId: encryptedInput.data,
          otpSystem: "aadhaar",
          abhaNumber: selectedAbha?.ABHANumber || abhaDetails?.abha?.ABHANumber,
          resent_count: resendCount,
        };
      }

      const response = await AlreadyAbhaVerifyAddress({
        headers: {},
        data: requestData,
      });

      if (response?.resent_count !== undefined) {
        dispatch(setResentCount(response.resent_count));
      }

      if (response.success === false) {
        toast.error(response.message || "Failed to send OTP");
        return;
      }
      if (response.success === true) {
        const txnId = response?.data?.txnId;
        if (txnId) localStorage.setItem("txnId", txnId);
        setResMessage(response.message);
        setVerifyNumberAbha(true);
      }
    } catch (err) {
      console.error(err);
      toast.error(
        err.message || "Something went wrong. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  const abhaList = getAbhaList();

  if (verifyNumberAbha) {
    return (
      <VerifyNumberAbha
        inputType="abhaaddress"
        otpType={authMethod}
        inputValue={inputValue}
        initialResentCount={resendCount}
        handleBack={() => setVerifyNumberAbha(false)}
        setResMessage={setResMessage}
        resMessage={resMessage}
        autoComplete="off"
      />
    );
  }

  return (
    <div className="col-12 col-md-6">
      <div
        className="lmop-card-wrap"
        style={{
          backgroundImage: `url(${formBgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="lmop-card-inner">
          <h3 className="lmop-card-title" style={{ fontSize: "1.2rem" }}>
            ABHA Number / ABHA Address
          </h3>
          <p className="lmop-card-subtitle">Select your ABHA to continue</p>

          {/* ABHA cards list */}
          <div style={{ maxHeight: "220px", overflowY: "auto", marginBottom: "16px" }}>
            {abhaList.length > 0 ? (
              abhaList.map((item, idx) => (
                <div
                  key={idx}
                  onClick={() => handleCardSelect(item)}
                  style={{
                    padding: "14px 16px",
                    borderRadius: "10px",
                    border: `1.5px solid ${
                      selectedAbha?.ABHANumber === item.ABHANumber
                        ? "#1a7fff"
                        : "#e2e5ec"
                    }`,
                    background:
                      selectedAbha?.ABHANumber === item.ABHANumber
                        ? "rgba(26,127,255,0.06)"
                        : "#f5f6f8",
                    marginBottom: "10px",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div>
                      <p
                        style={{
                          margin: "0 0 4px",
                          fontSize: "0.9rem",
                          fontWeight: "700",
                          color: "#111",
                        }}
                      >
                        {item.name}
                      </p>
                      <p style={{ margin: "0 0 2px", fontSize: "0.78rem", color: "#666" }}>
                        <strong>ABHA:</strong>{" "}
                        {`xx-xxxx-xxxx-${item.ABHANumber?.slice(-4)}`}
                      </p>
                      <p style={{ margin: "0 0 2px", fontSize: "0.78rem", color: "#666" }}>
                        <strong>ABHA Address:</strong> {item.abhaAddress}
                      </p>
                      <p style={{ margin: "0 0 2px", fontSize: "0.78rem", color: "#666" }}>
                        <strong>Gender:</strong> {item.gender}
                      </p>
                      <p style={{ margin: "0", fontSize: "0.78rem", color: "#666" }}>
                        <strong>KYC:</strong>{" "}
                        <span
                          style={{
                            color: item.kycVerified ? "#00c48c" : "#cf1f1f",
                            fontWeight: "600",
                          }}
                        >
                          {item.kycVerified ? "Verified" : "Not Verified"}
                        </span>
                      </p>
                    </div>

                    {/* Selection indicator */}
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        border: `2px solid ${
                          selectedAbha?.ABHANumber === item.ABHANumber
                            ? "#1a7fff"
                            : "#ccc"
                        }`,
                        background:
                          selectedAbha?.ABHANumber === item.ABHANumber
                            ? "#1a7fff"
                            : "transparent",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {selectedAbha?.ABHANumber === item.ABHANumber && (
                        <span
                          style={{
                            color: "#fff",
                            fontSize: "11px",
                            fontWeight: "700",
                          }}
                        >
                          ✓
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: "#888", fontSize: "0.85rem" }}>
                No ABHA records found.
              </p>
            )}
          </div>

          {/* Consent checkbox */}
          <div className="d-flex mb-3">
            <input
              type="checkbox"
              className="form-check-input checkbox-color"
              id="consentCheck"
              autoComplete="off"
              checked={consent}
              onChange={() => setConsent((v) => !v)}
            />
            <label
              className="form-check-label ps-2"
              htmlFor="consentCheck"
              style={{ fontSize: "0.8rem", color: "#555", lineHeight: "1.5" }}
            >
              I agree to give my consent to AbyM to link and update my
              details as per ABHA Address
            </label>
          </div>

          {/* Authentication Method */}
          <p
            style={{
              fontSize: "0.82rem",
              fontWeight: "700",
              color: "#333",
              marginBottom: "8px",
            }}
          >
            Choose Authentication Method
          </p>
          <div
            style={{
              display: "flex",
              gap: "12px",
              marginBottom: "16px",
              flexWrap: "wrap",
            }}
          >
            {[
              { value: "mobile", label: "Verify via Mobile OTP" },
              { value: "aadhaar", label: "Verify via Aadhaar OTP" },
            ].map((opt) => (
              <label
                key={opt.value}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 16px",
                  borderRadius: "999px",
                  border: `1.5px solid ${
                    authMethod === opt.value ? "#1a7fff" : "#e2e5ec"
                  }`,
                  background:
                    authMethod === opt.value
                      ? "rgba(26,127,255,0.06)"
                      : "#f5f6f8",
                  cursor: "pointer",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                  color: authMethod === opt.value ? "#1a7fff" : "#555",
                  transition: "all 0.2s",
                  userSelect: "none",
                }}
              >
                <input
                  type="radio"
                  name="auth"
                  value={opt.value}
                  autoComplete="off"
                  checked={authMethod === opt.value}
                  onChange={(e) => setAuthMethod(e.target.value)}
                  style={{ accentColor: "#1a7fff", width: "15px", height: "15px" }}
                />
                {opt.label}
              </label>
            ))}
          </div>

          {error && <p className="lmop-msg-err">{error}</p>}

          {/* Back + Link Now buttons */}
          <div className="d-flex gap-3">
            <button
              type="button"
              onClick={handleBack}
              style={{
                flex: 1,
                padding: "14px",
                borderRadius: "999px",
                border: "1.5px solid #d0d5e0",
                background: "transparent",
                color: "#555",
                fontFamily: "Manrope, sans-serif",
                fontWeight: "700",
                fontSize: "0.92rem",
                cursor: "pointer",
              }}
            >
              Back
            </button>
            <button
              type="button"
              className={`lmop-continue-btn ${
                !consent || loading ? "bg-disable" : ""
              }`}
              onClick={handleVerifyNumberAbha}
              disabled={!consent || loading}
              style={{ flex: 1, marginTop: 0 }}
            >
              {loading ? "Linking..." : "Link Now"}
            </button>
          </div>

          <div className="lmop-nha-row">
            <span className="lmop-nha-label">Approved by NHA</span>
            <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyAbhaAddress;